import networkTS from '@/misc/apis/networkTS'
import { PortalAddLinkEntry, PortalLink } from '@/types/api'

export interface PortalStatusResponse {
  enabled: boolean;
  propertyIds?: string[];
}

function normalizePortalStatus(response: any): PortalStatusResponse {
  const propertyIds = Array.isArray(response?.propertyIds)
    ? response.propertyIds.filter((id: unknown) => typeof id === 'string')
    : []

  return {
    enabled: Boolean(response?.enabled),
    propertyIds
  }
}

export default {
  async getPortalStatus(accountId: string) {
    return networkTS.portalServiceHasPortalEnabled(accountId).then(response => {
      return normalizePortalStatus(response.data)
    })
  },
  async updatePortalStatus(accountIds: string[], enable: boolean, propertyIds: string[] = []) {
    return networkTS.portalServiceEnablePortal({ accountIds: accountIds, enable: enable, propertyIds: propertyIds }).then(response => {
      return response.data
    })
  },
  isPropertyPortalEnabled(portalStatus: PortalStatusResponse, propertyId: string) {
    if (!portalStatus?.enabled) {
      return false
    }

    // Backward compatibility: old records may not have propertyIds yet.
    if (!Array.isArray(portalStatus.propertyIds) || portalStatus.propertyIds.length === 0) {
      return true
    }

    return portalStatus.propertyIds.includes(propertyId)
  },
  async addLinks(links: PortalAddLinkEntry[]) {
    return networkTS.portalServiceAddLinks({ links: links }).then(response => {
      return response.data
    })
  },
  async updateLinks(links: PortalLink[]) {
    return networkTS.portalServiceUpdateLinks({ links: links }).then(response => {
      return response.data
    })
  },
  async removeLinks(ids: string[]) {
    return networkTS.portalServiceRemoveLinks(ids).then(response => {
      return response.data
    })
  },
  async listLinksByReferenceIds(referenceIds: string[]) {
    return networkTS.portalServiceListLinksByReferenceIds({ referenceIds: referenceIds }).then(response => {
      return response.data
    })
  }
}
